import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  listData: [],
  isListInitialized: false,
  listSorting: null,
  selectedRowIndex: -1,
};

export const proposalsListSlice = createSlice({
  name: "list",
  initialState,
  reducers: {
    reset: () => initialState,
    removeById(state, { payload }) {
      state.listData = state.listData.filter(({ id }) => id !== payload);
    },
    setListData(state, { payload }) {
      state.listData = payload || [];
    },
    setIsListInitialized(state, { payload }) {
      state.isListInitialized = Boolean(payload);
    },
    setListSorting(state, { payload }) {
      state.listSorting = payload ?? null;
    },
    setSelectedRowIndex(state, { payload }) {
      state.selectedRowIndex = payload ?? -1;
    },
    updateListItemAssignees(state, { payload: { itemId, assignees } }) {
      const item = state.listData.find((row) => row.id === itemId);
      if (item) {
        item.assignees = assignees || [];
      }
    },
  },
});

export const {
  reset,
  removeById,
  setListData,
  setIsListInitialized,
  setListSorting,
  setSelectedRowIndex,
  updateListItemAssignees,
} = proposalsListSlice.actions;

export default proposalsListSlice;
